import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UpdateProgrammeStatusBody } from '@sparkapp/shared-types';
import { programmeApi } from '../services/programmeApi';
import { queryKeys } from '../utils/queryKeys';

/** Counts move while families onboard: refresh every minute while the dashboard is open. */
export function useProgrammeOverview() {
  return useQuery({
    queryKey: queryKeys.programme.overview(),
    queryFn: programmeApi.getOverview,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}

export function useChangeProgrammeStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ slug, ...body }: UpdateProgrammeStatusBody & { slug: string }) =>
      programmeApi.changeStatus(slug, body),
    // The PATCH returns the fresh overview: no second request.
    onSuccess: (overview) => queryClient.setQueryData(queryKeys.programme.overview(), { programme: overview }),
    // 409 (changed elsewhere): reload so the card shows the real status.
    onError: () => queryClient.invalidateQueries({ queryKey: queryKeys.programme.all }),
  });
}
